module.exports = __webpack_public_path__ + "static/03-67bce04b6b1c0e90e4e157aba24e1d45.jpg";